var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-style"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"item",class:{active: _vm.subtitle && item.name === _vm.subtitle.font.textAlign},on:{"click":function($event){return _vm.select(item)}}},[_c('i',{staticClass:"icon",class:[item.name]})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ed9e1eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subtitle/subtitlePanel/textAlign.vue
// module id = null
// module chunks = 